const konami = require("./eh-konami.js");
const HT = require("../tetris/tetris_gui.js");

/*
 * Install the tetris Konami trigger :-). Enjoy!
 */
konami.action=function() {
  // Get the body
  var b=top.document.getElementsByTagName('body')[0];

  // create the target div
  var d=top.document.createElement('div');
  b.appendChild(d);

  // customise the div
  if (HT.customise_div) HT.customise_div(d);
  if (!top.document.getElementById("tetris-div"))
    d.setAttribute("id", "tetris-div");

  //load Ham Tetris JS
  HT.install("tetris-div");
  // tetris_logic load triggers tetris_gui load
  konami.orig_action = konami.action;
  konami.action=function() {
    top.document.getElementById('tetris-music').play();
  };
};

module.exports = {konami: konami, HT: HT};
